import { useContext, useEffect, useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { EcUserDataContext } from "@eclear-ag/ec-common-ui";
import SubscriptionsDetails from "./subscriptions-details";
import ManageProfileContext from "../../../services/manage-profile/manageProfile";

/**
 * URL-driven wrapper around SubscriptionsDetails: re-derives which
 * subscription to show from the :productType route param alone, so a fresh
 * or copy-pasted URL load works the same as arriving via a list-item click.
 */
export default function SubscriptionDetailRoute() {
  const { productType } = useParams();
  const { getMeData, isFetchingGetMeData, checkGetMeData } = useContext(
    EcUserDataContext
  );
  const { setSubsciptionDetails } = useContext(ManageProfileContext);

  useEffect(() => {
    checkGetMeData?.();
  }, [checkGetMeData]);

  const hasLoadedSubscriptions = Array.isArray(getMeData?.userSubscriptions);

  const matchedSubscription = useMemo(() => {
    const subscriptions = getMeData?.userSubscriptions || [];
    return subscriptions.find(
      (item) => item?.status === "ENABLED" && item?.productType === productType
    );
  }, [getMeData, productType]);

  useEffect(() => {
    if (matchedSubscription) setSubsciptionDetails(matchedSubscription);
  }, [matchedSubscription, setSubsciptionDetails]);

  if (!hasLoadedSubscriptions || isFetchingGetMeData) {
    return null;
  }

  if (!matchedSubscription) {
    return <Navigate to="/spot/manage-profile?tab=subscriptions" replace />;
  }

  return <SubscriptionsDetails />;
}
